import React from "react"
import { ChevronLeft, Search, Home } from "react-feather"
import Cookies from 'js-cookie'

import "./CoolPage.less"

const homeUrl = Cookies.get('tepaRoom') ? '/catalogo/tepa' : "/catalogo/Madrid/"

const Bar = ({
  barButton,
  title,
  titleComponent,
  goBack,
  push,
  history,
  backOnClick,
  gotoSearch,
  withSearchButton = false,
  isChevron = true,
  scrollTop,
  height,
  width, /* JESUS: idk why this width is necessary, but i don't dare remove it */
  barColor, // this is needed to customize color for non-fixed bars
  fixedBar = false
}) => {
  const pinkBar = fixedBar || scrollTop < height / 20
  const titleOpacity = fixedBar ? 1 : (scrollTop / (height / 8))
  
  const chevronBg = fixedBar ? "transparent" : `rgba(0, 0, 0, ${0.5 - (scrollTop / (height / 9))})`
  const bg = fixedBar 
    ? {} 
    : { backgroundColor: `rgba(${barColor[0]}, ${barColor[1]}, ${barColor[2]}, ${0 + (scrollTop / 100)})` }
  
  return (
    <div
      className={
        (pinkBar ? "top-bar white " : "top-bar transparent ")
        + (fixedBar ? "fixed " : "")
        + (scrollTop == 0 || fixedBar ? "top " : "")
      }
      style={{ width, ...bg, }}
    >
      {history.length == 1 
        ? (
          <div
            onClick={() => push(homeUrl)}
            className="chevron"
            style={{
              visibility: isChevron ? "visible" : "hidden",
              backgroundColor: chevronBg,
              color: "white", // "#007AFF",
            }}
          >
            <Home size="4.5vh" style={{flexShrink: 0}} />
          </div>
        )
        : (
          <div
            onClick={() => (backOnClick ? backOnClick() : goBack())}
            className="chevron"
            style={{
              visibility: isChevron ? "visible" : "hidden",
              backgroundColor: chevronBg,
              color: "white", // "#007AFF",
            }}
          >
            <ChevronLeft size="6vh" style={{flexShrink: 0}} />
          </div>)
      }

      { titleComponent || (<h1 style={{opacity: titleOpacity}}>{title}</h1>) }

      {
        !withSearchButton && (
          <div className="right">{barButton}</div>
        )
      }

      {
        (withSearchButton == "onlyOnBar" ? (scrollTop >= height / 20) : withSearchButton) && (
          pinkBar
            ? (
              <div
                onClick={() => gotoSearch()}
                className="chevron"
                style={{
                  marginRight: 5,
                  backgroundColor: `rgba(0, 0, 0, ${0.5 - (scrollTop / (height / 9))})`,
                  color: "white"
                }}
              >
                <Search size="4vh" style={{ flexShrink: 0 }} />
              </div>
            )
            : (
              <div
                onClick={() => gotoSearch()}
                className="chevron"
                style={{
                  marginRight: 5,
                  paddingLeft: 5,
                  backgroundColor: `rgba(0, 0, 0, ${0.5 - (scrollTop / (height / 9))})`,
                  color: "white"
                }}
              >
                <Search size="4vh" style={{ flexShrink: 0 }} />
              </div>
            )
        )
      }
    </div>
  )
}

export default Bar



// WEBPACK FOOTER //
// ./src/app/catalogo/components/CoolPage.Bar.jsx